(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["everbright-ai-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const controls = document.getElementById('EverBrightAIControls');
    const closeButton = controls?.querySelector('[data-ai-chat-close]');
    const status = controls?.querySelector('[data-ai-status]');
    if (!controls || !closeButton || !status) return;

    let widget = document.getElementById('EverBrightAIWidget');
    let observer;
    let opener;
    let connecting = false;
    let connected = false;
    let sawEndButton = false;
    let closing = false;
    let reloadAvailable = false;
    let attachTimer;
    let stopTimer;

    const nativeButton = label => Array.from(widget?.shadowRoot?.querySelectorAll('button') || [])
      .find(button => button.getAttribute('aria-label') === label);
    const endButton = () => nativeButton(closeButton.dataset.nativeEndLabel);
    const startButton = () => nativeButton(closeButton.dataset.nativeStartLabel);

    function finishClose() {
      observer?.disconnect();
      window.clearInterval(attachTimer);
      window.clearTimeout(stopTimer);
      const replacement = widget.cloneNode(false);
      replacement.classList.remove('is-open');
      widget.replaceWith(replacement);
      widget = replacement;
      controls.hidden = true;
      connecting = connected = sawEndButton = closing = reloadAvailable = false;
      closeButton.textContent = closeButton.dataset.closeLabel;
      status.textContent = '';
      document.querySelectorAll('[data-ai-chat-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (opener?.isConnected) opener.focus();
    }

    function completeStop() {
      const end = endButton();
      if (end && !end.disabled && !connecting) {
        end.click();
        finishClose();
      } else if (!end && !connecting && !connected) {
        finishClose();
      }
    }

    function stopAndClose() {
      if (reloadAvailable) {
        window.location.reload();
        return;
      }
      if (closing || !widget || controls.hidden) return;
      closing = true;
      closeButton.textContent = closeButton.dataset.stoppingLabel;
      status.textContent = closeButton.dataset.stoppingLabel;
      stopTimer = window.setTimeout(() => {
        if (!closing) return;
        reloadAvailable = true;
        closeButton.textContent = closeButton.dataset.reloadLabel;
      }, 5000);
      completeStop();
    }

    function updateControls() {
      const end = endButton();
      const start = startButton();
      if (end) sawEndButton = true;
      if (sawEndButton && !end && start && !start.disabled) {
        connecting = connected = sawEndButton = false;
      }
      if (closing) {
        completeStop();
        return;
      }
      closeButton.textContent = end || connecting || connected ? closeButton.dataset.endLabel : closeButton.dataset.closeLabel;
    }

    function attachWidget() {
      if (!widget?.shadowRoot) return false;
      observer?.disconnect();
      observer = new MutationObserver(updateControls);
      observer.observe(widget.shadowRoot, { childList: true, subtree: true, attributes: true });
      updateControls();
      return true;
    }

    document.addEventListener('elevenlabs-convai:call', event => {
      if (event.target !== widget || !event.detail?.config) return;
      const callingWidget = widget;
      const config = event.detail.config;
      const originalConnect = config.onConnect;
      const originalError = config.onError;
      connecting = true;
      updateControls();
      config.onConnect = (...args) => {
        try {
          originalConnect?.(...args);
        } finally {
          window.setTimeout(() => {
            if (widget !== callingWidget) return;
            connecting = false;
            connected = true;
            updateControls();
          }, 0);
        }
      };
      config.onError = (...args) => {
        try {
          originalError?.(...args);
        } finally {
          window.setTimeout(() => {
            if (widget !== callingWidget) return;
            updateControls();
          }, 0);
        }
      };
    });

    document.querySelectorAll('[data-ai-chat-open]').forEach(button => {
      button.setAttribute('aria-controls', 'EverBrightAIWidget');
      button.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-ai-chat-open]');
      if (trigger) {
        if (!widget || closing) return;
        opener = trigger;
        widget.classList.add('is-open');
        controls.hidden = false;
        document.querySelectorAll('[data-ai-chat-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
        closeButton.focus();
        window.clearInterval(attachTimer);
        if (!attachWidget()) {
          let attempts = 0;
          attachTimer = window.setInterval(() => {
            if (attachWidget() || ++attempts >= 50) window.clearInterval(attachTimer);
          }, 200);
        }
      } else if (event.target.closest?.('[data-ai-chat-close]')) {
        stopAndClose();
      }
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !controls.hidden) {
        event.preventDefault();
        if (!reloadAvailable) stopAndClose();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('everbright-info-swish')) {
  customElements.define('everbright-info-swish', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true' || this.dataset.swishState === 'visible') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      this.swishObserver?.disconnect();
      this.dataset.swishState = 'pending';
      this.swishObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.6)) return;
        this.dataset.swishState = 'visible';
        this.swishObserver?.disconnect();
        this.swishObserver = null;
      }, { threshold: 0.6, rootMargin: '0px 0px -48px 0px' });
      this.swishObserver.observe(this);
    }
    disconnectedCallback() {
      this.swishObserver?.disconnect();
      this.swishObserver = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
